import { adminTypes } from "app/redux/type/adminTypes";

const initialState = {
  isLoading: false,
  shopList: null,
  queryDetails: null,
  msg: "",
};
export const shopListReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminTypes.GET_SHOP_DETAIL_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_SHOP_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        shopList: action.payload,
        msg: "",
      };
    case adminTypes.GET_SHOP_DETAIL_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        shopList: action.payload,
        msg: action.msg,
      };
    case adminTypes.GET_SHOP_DETAIL_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_SHOP_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        queryDetails: action.payload,
        msg: "",
      };
    case adminTypes.GET_SHOP_DETAIL_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        queryDetails: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};
